//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "staffentryworkinfo",
    props:{
        //业务数据
        record:{type:Object,default: () => ({})},
        //流程数据
        process:{type:Object,default: () => ({})},
        //规则绑定
        rules:{type: Object,default: () => ({})},
        //自定义的参数
        config: {type: Object, default: () => ({})},
    },
    data(){
      return{

        //是否隐藏id，true为显示
        hideId:false,
      }
    },
    methods:{
      /**
       * 初始化下拉框
       */
      initSelect(){
      },
      /**
       * 校验履历开始和结束日期
       */
      async checkresumtime(){
          var len = this.record.staffresumerow.length;
          var flag = true;
          for(let i = 0 ; i < len; i++ ){
            if(this.record.staffresumerow[i].resumebegintime !=null && this.record.staffresumerow[i].resumebegintime != ''
              && this.record.staffresumerow[i].resumeendtime !=null && this.record.staffresumerow[i].resumeendtime != ''){
                  let begintime = this.forMatDate(this.record.staffresumerow[i].resumebegintime);
                  let endtime = this.forMatDate(this.record.staffresumerow[i].resumeendtime);  
                  if (begintime > endtime) {
                    flag = false
                  }
            }
          }
          return flag;
      }
    },
    created() {
        this.initSelect();
    },
}



// WEBPACK FOOTER //
// ./src/pcpage/hr/personnel/staffentry/staffentryresumeinfo.vue